



















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop() id: number | undefined;
  model: proxy.MerchantAndMerBinDingDto = new proxy.MerchantAndMerBinDingDto();
  ctypes: any[] = [];
  apitypes: any[] = [];
  get prox() {
    return new proxy.MerchantAndMerBinDingServiceProxy();
  }
  save() {
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.prox.createOrUpdate(this.model).then(() => {
          (this.$refs.roleForm as any).resetFields();
          this.$Notice.success({ title: "保存成功" });
          this.$emit("save-success");
          this.$emit("input", false);
        });
      }
    });
  }

  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.prox.queryModel(this.id).then((x) => {
        this.model = x;
      });
      let req2 = new proxy.AgentPageInputDto();
      req2.status = 0;
      req2.maxResultCount = 100;
    }
  }

  roleRule = {
    suppName: [
      {
        required: true,
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
  };
}
